import { ChangeDetectionStrategy, Component, computed, Inject, Signal, signal, WritableSignal } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AvatarModule } from 'ngx-avatars';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-color-picker-dialogue',
  imports: [CommonModule, MatButtonModule, MatDialogModule, AvatarModule, FormsModule],
  templateUrl: './color-picker-dialogue.component.html',
  styleUrl: './color-picker-dialogue.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ColorPickerDialogueComponent {
  colors: WritableSignal<string[]>= signal<string[]>([
    '#C0CBD6', '#F98C82', '#FFCC7E', '#8DDF99', '#72D0BB',
    '#4ABADE', '#63B3FF', '#82ACFF', '#799AF0', '#A484EA', '#FA7DB8', '#FE7E80'
  ]);
  selectedColor: WritableSignal<string> = signal<string>('');
  avatarText: WritableSignal<string> = signal<string>('');
  initialColor: WritableSignal<string> = signal<string>('');
  isChangedDisabled: Signal<boolean> = computed(() => {
    return this.selectedColor() === this.initialColor() ? true : false
  });

  constructor(
    public dialogRef: MatDialogRef<ColorPickerDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedColor: string , avatarName: string}
  ) {
    this.selectedColor.set(data.selectedColor);
    this.avatarText.set(data.avatarName);
    this.initialColor.set(data.selectedColor);
  }

  selectColor(color: string) {
    this.selectedColor.set(color);
  }

  confirm() {
    this.dialogRef.close(this.selectedColor());
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
